export class BadRequestApiError extends Error {
  constructor(message?: string) {
    super(message ?? 'Unable to process request')
    Object.setPrototypeOf(this, BadRequestApiError.prototype)
  }
}
